// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';
import { Proposal } from './proposal';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProposalDiscussion extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  deleted?: Date;
  note?: string;
  personId?: number;
  proposalId!: number;
  person!: Person;
  proposal!: Proposal;
}

